import requestor from "../../requestor";

export default class UserApi {
  autocomplete = (query, page = 1, limit = 10) =>
    requestor.get("/manage/user_autocomplete", { query: query, page: page, limit: limit });
}
